import { ApiBase, ApiResponse } from '../api-base';
import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { CustomIntervalEntity } from './custom-interval-entity';

@inject(IHttpClient)
export class CustomIntervalApi extends ApiBase {

    constructor(http: IHttpClient) {
        super(http);
    }

    public async add(scheduleId: string, entity: CustomIntervalEntity): Promise<CustomIntervalEntity> {
        const dto = entity.toDto();
        const response = await this.post(this._baseUrl(scheduleId), dto);
        return CustomIntervalEntity.fromDto(response.content);
    }

    public async update(scheduleId: string, id: string, entity: CustomIntervalEntity): Promise<CustomIntervalEntity> {
        const dto = entity.toDto();
        const response = await this.patch(this._baseUrl(scheduleId) + '/' + id, dto);
        return CustomIntervalEntity.fromDto(response.content);
    }

    public async getById(scheduleId: string, id: string): Promise<CustomIntervalEntity> {
        const response = await this.get(this._baseUrl(scheduleId) + '/' + id);
        return CustomIntervalEntity.fromDto(response.content);
    }

    // public async getByScheduleId(scheduleId: string): Promise<CustomIntervalEntity> {
    //   const response = await this.get(this._baseUrl(scheduleId));
    //   return CustomIntervalEntity.fromDto(response.content);
    // }

    public async getByScheduleId(scheduleId: string): Promise<CustomIntervalEntity[]> {
        const response = await this.get(this._baseUrl(scheduleId));
        return CustomIntervalEntity.fromDtoArray(response.content);
    }

    public async deleteByScheduleId(scheduleId: string): Promise<ApiResponse> {
        const response = await super.delete(this._baseUrl(scheduleId));
        return response.content;
    }

    public async deleteById(scheduleId: string, id: string): Promise<ApiResponse> {
        const response = await super.delete(this._baseUrl(scheduleId) + '/' + id);
        return response.content;
    }

    private _baseUrl(scheduleId: string): string {
        return `api/schedules/${scheduleId}/customintervals`;
    }
}
